import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS'
import PrintWeekProgramFlyerChoosenMoviesList from './PrintWeekProgramFlyerChoosenMoviesList'
import { addWeekProgramFlyerMovie, deleteWeekProgramFlyerMovie, updateWeekProgramFlyerOrder } from '../../../actions'

const mapStateToProps = state => ({
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    addWeekProgramFlyerItem: (section, itemId, itemType) => {
        dispatch(addWeekProgramFlyerMovie({
            id: itemId
        }))
    },
    deleteWeekProgramFlyerItem: (itemId) => {
        dispatch(deleteWeekProgramFlyerMovie(itemId))
    },
    reorderWeekProgramFlyerItems: (dragIndex, hoverIndex) => {
        const order = ownProps.weekProgramFlyerData.choosenMovies.order
        const movedElement = order.splice(dragIndex, 1)[0];
        order.splice(hoverIndex, 0, movedElement);
        dispatch(updateWeekProgramFlyerOrder(order, 'choosenMovies'))
    }
})

const PrintWeekProgramFlyerChoosenMoviesListContainer = ({
    weekProgramFlyerData,
    displayDropzones,
    addWeekProgramFlyerItem,
    deleteWeekProgramFlyerItem,
    reorderWeekProgramFlyerItems,
    relevantMovies,
    basicUrl,
}) => {
    return (
        <PrintWeekProgramFlyerChoosenMoviesList
            weekProgramFlyerData={weekProgramFlyerData}
            displayDropzones={displayDropzones}
            addWeekProgramFlyerItem={addWeekProgramFlyerItem}
            reorderWeekProgramFlyerItems={reorderWeekProgramFlyerItems}
            deleteWeekProgramFlyerItem={deleteWeekProgramFlyerItem}
            relevantMovies={relevantMovies}
            basicUrl={basicUrl}
      />
    )
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(PrintWeekProgramFlyerChoosenMoviesListContainer)